import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Modal, Tab, Tabs } from "react-bootstrap";
import {
  Calender,
  DropDown,
  TextInputForm,
  DropDownUI,
  DropDownUItest,
} from "../components/Forms";
import { PageHead } from "../components/PageTitle";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useNavigate, Navigate } from "react-router-dom";
import {
  Buttons,
  Dltbtn,
  ClickButton,
  InstantCreate,
  Delete,
} from "../components/Buttons";
import { BiPlus } from "react-icons/bi";
import API_DOMAIN from "../config/config";

import PropagateLoader from "react-spinners/PropagateLoader";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDeleteForever } from "react-icons/md";
import moment from "moment/moment";
import companyId from "../config/companyId";
import "./purchasebills.css";

// PurchaseBillEntry start
const alltax = [
  { value: "GST@0%", label: "GST@0%" },
  { value: "IGST@5%", label: "IGST@5%" },
  { value: "GST@5%", label: "GST@5%" },
];

const parseToDate = (dateString) => {
  if (!dateString) return new Date();
  const parsed = moment(dateString, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
  return parsed.isValid() ? parsed.toDate() : new Date();
};

// Imports and other constants remain unchanged
const normalizeTaxPercentage = (taxPercentage, taxType) => {
  if (!taxPercentage) {
    return "";
  }
  const percentage =
    parseFloat(taxPercentage.toString().match(/\d+\.*\d*/)?.[0]) || 0;
  const type = taxType?.toUpperCase() || "GST";
  const normalizedValue = `${type}@${percentage}`;
  return alltax.some((tax) => tax.value === normalizedValue)
    ? normalizedValue
    : "";
};

const PurchaseBillEntry = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const navigate = useNavigate();
  const [tax_type, settax_type] = useState("");
  console.log("rowData =>", rowData);
  const initialState =
    type === "edit"
      ? {
        ...rowData,
        bill_date: parseToDate(rowData.bill_date),
        stock_date: parseToDate(rowData.stock_date),
        payment_method: rowData.payment_method || "",
        remark: rowData.remark || "",
        driver_name: rowData.driver_name || "",
        driver_phone: rowData.driver_phone || "",
        vehicle_no: rowData.vehicle_no || "",
        vehicle_type: rowData.vehicle_type || "",
        product: rowData.product.map((product) => ({
          ...product,
          tax_percentage: product.tax_percentage,
        })),
      }
      : {
        party_id: "",
        bill_no: "",
        bill_date: new Date(),
        stock_date: new Date(),
        purchase_gst: "",
        purchasemobile_no: "",
        total: "",
        paid: 0,
        balance_amount: "",
        final_total: "",
        discount_all: "",
        total_discountall: "",
        taxover_amt: "",
        taxover_percentage: "",
        round_off_checkbox: "",
        remark: "",
        payment_method: "",
        driver_name: "",
        driver_phone: "",
        vehicle_no: "",
        vehicle_type: "",
        product: [
          {
            product_id: "",
            qty: "",
            unit: "",
            price_unit: "",
            discount_percentage: "",
            discount_amt: "",
            tax_type: "",
            tax_percentage: "0",
            tax_amt: "",
            total_amt: "",
            SGST: "0.00",
            CGST: "0.00",
            IGST: "0.00",
          },
        ],
      };
  const [formData, setFormData] = useState(initialState);

  const [crtPaymentMethod, setCrtPaymentMethod] = useState([]);

  //
  const setLabel = (date, type) => {
    if (date instanceof Date && !isNaN(date)) {
      setFormData((prev) => ({
        ...prev,
        [type]: date,
      }));
    } else {
    }
  };

  const [showQtyModal, setShowQtyModal] = useState(false);
  const [currentQtyRowIndex, setCurrentQtyRowIndex] = useState(null);
  const [additionalQty, setAdditionalQty] = useState("");

  const handleOpenQtyModal = (index) => {
    setCurrentQtyRowIndex(index);
    setAdditionalQty("");
    setShowQtyModal(true);
  };

  const handleQtyAddition = () => {
    if (currentQtyRowIndex === null) return;
    const currentQty = parseFloat(formData.product[currentQtyRowIndex].qty) || 0;
    const addQty = parseFloat(additionalQty) || 0;
    const newQty = (currentQty + addQty).toString();

    // Trigger calculation by calling handleChange with the new quantity
    handleChange({ target: { value: newQty } }, "qty", currentQtyRowIndex);

    setShowQtyModal(false);
    setAdditionalQty("");
    setCurrentQtyRowIndex(null);
  };

  const handleAddRow = () => {
    setFormData((prevState) => ({
      ...prevState,
      product: [...prevState.product, {}],
    }));
  };

  // Delete a row from the product list
  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      product: prevState.product.filter((_, i) => i !== index),
    }));
  };

  // Handle change in total amount
  const handleTotalChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      total: e.target.value,
    }));
  };

  // Handle change in paid amount
  const handlePaidChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      paid: e.target.value,
    }));
  };
  const calculateTotal = (product) => {
    const totalAmount = product.reduce(
      (acc, row) => acc + parseFloat(row.total_amt || 0),
      0
    );

    setFormData((prevData) => ({
      ...prevData,
      total: totalAmount.toFixed(2),
    }));
  };
  // Handle key press event
  const handleKeyPress = (event, index) => {
    if (event.key === "Enter") {
      const lastRow = formData.product[formData.product.length - 1];
      if (
        lastRow.product_id &&
        lastRow.qty &&
        lastRow.unit &&
        lastRow.price_unit &&
        lastRow.total_amt
      ) {
        handleAddRow();
      } else {
        toast.error(
          "Please fill in all fields in the last row before adding a new row"
        );
      }
    }
  };

  const handleChange = (e, fieldName, rowIndex) => {
    const value = e.target ? e.target.value : e.value;
    let updatedFormData = { ...formData };

    // Update the field based on whether it's a product field or a top-level field
    if (rowIndex !== undefined) {
      updatedFormData = {
        ...formData,
        product: formData.product.map((row, index) =>
          index === rowIndex ? { ...row, [fieldName]: value } : row
        ),
      };
    } else {
      updatedFormData = {
        ...formData,
        [fieldName]: value,
      };
    }

    // Only recalculate product-related fields if the change is related to products
    if (
      rowIndex !== undefined &&
      [
        "qty",
        "price_unit",
        "discount_percentage",
        "discount_amt",
        "tax_percentage",
      ].includes(fieldName)
    ) {
      updatedFormData.product.forEach((row, index) => {
        const qty = parseFloat(row.qty) || 0;
        const price = parseFloat(row.price_unit) || 0;
        const discountPercentage = parseFloat(row.discount_percentage) || 0;
        const discountInputAmount = parseFloat(row.discount_amt) || 0;
        // Safely parse tax_percentage
        let taxPercentage = 0;
        if (typeof row.tax_percentage === "string" && row.tax_percentage) {
          const match = row.tax_percentage.match(/\d+\.*\d*/);
          taxPercentage = match ? parseFloat(match[0]) || 0 : 0;
        } else if (typeof row.tax_percentage === "number") {
          taxPercentage = row.tax_percentage;
        }
        const taxtype = row.tax_type || "";

        let crtdiscountFiled = 0.0;

        let subtotal = qty * price;
        if (fieldName === "price_unit" || fieldName === "qty") {
          crtdiscountFiled = (subtotal * discountPercentage) / 100;
          updatedFormData.product[index].discount_amt =
            crtdiscountFiled.toFixed(2);
        }
        if (fieldName === "discount_percentage") {
          crtdiscountFiled = (subtotal * discountPercentage) / 100;
          updatedFormData.product[index].discount_amt =
            crtdiscountFiled.toFixed(2);
        } else if (fieldName === "discount_amt") {
          crtdiscountFiled = discountInputAmount;
          const cal = subtotal > 0 ? (crtdiscountFiled / subtotal) * 100 : 0;
          updatedFormData.product[index].discount_percentage = cal.toFixed(2);
        }

        const tmpsubtotal = subtotal - crtdiscountFiled;
        const taxAmount = (tmpsubtotal * taxPercentage) / 100;
        const finalAmount = tmpsubtotal + taxAmount; // Include tax in total_amt

        // Update SGST, CGST, IGST consistently
        let sgst = 0,
          cgst = 0,
          igst = 0;
        if (taxtype === "IGST") {
          igst = taxAmount;
        } else if (taxtype === "GST") {
          sgst = taxAmount / 2;
          cgst = taxAmount / 2;
        }

        updatedFormData.product[index].tax_amt = taxAmount.toFixed(2);
        updatedFormData.product[index].total_amt = finalAmount.toFixed(2); // Correct total_amt
        updatedFormData.product[index].SGST = sgst.toFixed(2);
        updatedFormData.product[index].CGST = cgst.toFixed(2);
        updatedFormData.product[index].IGST = igst.toFixed(2);
      });

      const totalAmount = updatedFormData.product.reduce(
        (acc, row) => acc + parseFloat(row.total_amt || 0),
        0
      );
      updatedFormData.total = totalAmount.toFixed(2);
      updatedFormData.balance_amount = (
        totalAmount - parseFloat(updatedFormData.paid || 0)
      ).toFixed(2);
    }

    setFormData(updatedFormData);
  };

  function calculateTax(product, tax_percentage, index, taxType) {
    let updatedFormData = { ...formData };
    let sgst = 0,
      cgst = 0,
      igst = 0;

    const qty = parseFloat(product.qty) || 0;
    const price = parseFloat(product.price_unit) || 0;
    const discount = parseFloat(product.discount_amt) || 0;
    const taxPercentage = tax_percentage
      ? parseFloat(tax_percentage.match(/\d+\.*\d*/)?.[0]) || 0
      : 0;

    const subtotal = qty * price;
    const tmpsubtotal = subtotal - discount;
    const taxAmt = (tmpsubtotal * taxPercentage) / 100;
    const finalAmount = tmpsubtotal + taxAmt;

    if (taxType === "GST") {
      sgst = taxAmt / 2;
      cgst = taxAmt / 2;
    } else if (taxType === "IGST") {
      igst = taxAmt;
    }

    updatedFormData.product[index].SGST = sgst.toFixed(2);
    updatedFormData.product[index].CGST = cgst.toFixed(2);
    updatedFormData.product[index].IGST = igst.toFixed(2);
    updatedFormData.product[index].tax_type = taxType;
    updatedFormData.product[index].tax_amt = taxAmt.toFixed(2);
    updatedFormData.product[index].tax_percentage = tax_percentage || "0";
    updatedFormData.product[index].total_amt = finalAmount.toFixed(2);

    // Recalculate total and balance
    const totalAmount = updatedFormData.product.reduce(
      (acc, row) => acc + parseFloat(row.total_amt || 0),
      0
    );
    updatedFormData.total = totalAmount.toFixed(2);
    updatedFormData.balance_amount = (
      totalAmount - parseFloat(updatedFormData.paid || 0)
    ).toFixed(2);

    setFormData(updatedFormData);
  }
  useEffect(() => {
    calculateTotal(formData.product);
  }, [formData.product]);
  useEffect(() => {
    const updateBalance = () => {
      const total = parseFloat(formData.total);
      const paid = parseFloat(formData.paid);

      const balance = !isNaN(total) && !isNaN(paid) ? total - paid : "";

      setFormData((prevFormData) => ({
        ...prevFormData,
        balance_amount: balance.toString(),
      }));
    };

    updateBalance();
  }, [formData.total, formData.paid]);

  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [productData, setProductData] = useState([]);
  //
  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const response = await fetch(
          `${API_DOMAIN}/products.php?id=${companyId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              search_text: "",
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const responseData = await response.json();
        setLoading(responseData);
        if (responseData.status === 200 && Array.isArray(responseData.data)) {
          const validData = responseData.data.filter(
            (item) => item && typeof item.product_name === "string"
          );
          setProductData(validData);
        } else {
          throw new Error(responseData.msg);
        }
      } catch (error) {
        setLoading();
      }
    };

    fetchProductData(); // Call fetchData directly in useEffect
  }, []);
  const [UnitData, setUnitData] = useState([]);
  const fetchUnitData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/unit.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      setLoading(false);
      if (responseData.status === 200) {
        setUnitData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const [purchseParty, setPurchaseparty] = useState([]);
  const fetchDatapurchseParty = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/purchase_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
          company_id: companyId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      setLoading(false);
      if (responseData.status === 200) {
        setPurchaseparty(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const fetchDataPaymentMethod = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/paymentmethod.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: "",
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      if (responseData.status === 200) {
        setCrtPaymentMethod(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUnitData(); // Call fetchData directly in useEffect
    fetchDatapurchseParty();
    fetchDataPaymentMethod();
  }, []);
  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const handleSubmit = async () => {
    console.log("Submitting formData =>", formData);
    setLoading(true);
    try {
      const formattedFormData = {
        ...formData,
        bill_date: moment(formData.bill_date).format("YYYY-MM-DD"),
        stock_date: moment(formData.stock_date).format("YYYY-MM-DD"),
      };
      const response = await fetch(
        `${API_DOMAIN}/purchase_bill.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formattedFormData),
        }
      );

      const responseData = await response.json();
      if (responseData.status === 200) {
        setFormData({
          party_id: "",
          bill_no: "",
          bill_date: "",
          total: "",
          paid: "",
          balance_amount: "",
          final_total: "",
          discount_all: "",
          purchasemobile_no: "",
          purchase_gst: "",
          total_discountall: "",
          taxover_amt: "",
          taxover_percentage: "",
          round_off_checkbox: "",
          driver_name: "",
          driver_phone: "",
          vehicle_no: "",
          vehicle_type: "",
          product: [
            {
              product_id: "",
              qty: "",
              unit: "",
              price_unit: "",
              discount_percentage: "",
              discount_amt: "",
              tax_percentage: "",
              tax_amt: "",
              total_amt: "",
            },
          ],
        });
        successAlert(responseData.msg);
        setTimeout(() => {
          navigate("/console/purchase/bill");
        }, 3000);
      } else if (responseData.status === 400) {
        toast.error("Missing required fields!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        setShowAlert(true);
      }
    } catch (error) {
    }
  };
  //
  const handleUpdateSubmit = async () => {
    try {
      // Format date fields
      const formattedFormData = {
        ...formData,
        bill_date: moment(formData.bill_date).format("YYYY-MM-DD"),
        stock_date: moment(formData.stock_date).format("YYYY-MM-DD"),
      };

      const response = await fetch(
        `${API_DOMAIN}/purchase_bill.php?id=${companyId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formattedFormData),
        }
      );
      const responseData = await response.json();
      if (responseData.status === 200) {
        toast.success("PurchaseBill updated successfully!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/console/purchase/bill");
        }, 2000);
      } else {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   setLoading(true);

  //   setTimeout(() => {
  //     setLoading(false);
  //   });
  // });

  useEffect(() => {
  setLoading(true);
  setTimeout(() => {
    setLoading(false);
  });
}, []); // ← empty array add pannu

  useEffect(() => {
    // Check if party_id is selected
    if (formData.party_id) {
      // Find the selected party in partySalesData
      const selectedParty = purchseParty.find(
        (party) => party.party_id === formData.party_id
      );

      if (selectedParty) {
        // Update formData with party data
        setFormData((prevFormData) => ({
          ...prevFormData,
          purchasemobile_no: selectedParty.mobile_number || "",
          purchase_gst: selectedParty.gst_no || "",
        }));
      }
    }
  }, [formData.party_id, purchseParty]);

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        // Check session logic here, e.g., fetch from local storage or server
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  const optionlist = productData.map((user) => ({
    value: user.product_id,
    label: `${user.product_name}`,
    data: { product_code: user.product_code || "" },
  }));
  const handleRemarkChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  return (
    <>
      <div style={{ cursor: "pointer" }}>
        <Container fluid className="mt-3">
          <div className="main">
            <Container fluid>
              <Row>
                <Col lg="12">
                  <PageHead
                    pagehead={<>Purchase Bill</>}
                    onClick={() => navigate(-1)}
                  />
                </Col>
              </Row>
            </Container>
          </div>

          <div className="main my-3 overflow-scroll">
            <div>
              <Container fluid>
                <Row>
                  <Col lg="12">
                    <Container fluid>
                      {/* Row 1 */}
                      <Row>
                        <Col xs={12} md={6} lg={2} className="mb-3">
                          <DropDownUI
                            optionlist={purchseParty.map((user) => ({
                              value: user.party_id,
                              label: user.party_name,
                            }))}
                            placeholder="Party Name"
                            labelname="Party Name"
                            name="party_id"
                            value={formData.party_id}
                            onChange={(updatedformData) =>
                              setFormData({
                                ...formData,
                                party_id: updatedformData.party_id,
                              })
                            }
                          />
                        </Col>

                        <Col xs={12} md={6} lg={2} className="mb-3">
                          <TextInputForm
                            placeholder={"PartyMobileNumber"}
                            labelname={"PartyMobileNumber"}
                            name="purchasemobile_no"
                            value={formData.purchasemobile_no}
                            onChange={(e) =>
                              handleChange(e, "purchasemobile_no")
                            }
                          />
                        </Col>

                        {/* <Col xs={12} md={6} lg={2} className="mb-3">
                          <TextInputForm
                            placeholder={"PartyGST"}
                            labelname={"PartyGST"}
                            name="purchase_gst"
                            value={formData.purchase_gst}
                            onChange={(e) => handleChange(e, "purchase_gst")}
                          />
                        </Col> */}
                        <Col xs={12} md={6} lg={2} className="mb-3">
                          <TextInputForm
                            placeholder={"Bill Number"}
                            labelname={"Bill Number"}
                            name="bill_no"
                            value={formData.bill_no}
                            onChange={(e) => handleChange(e, "bill_no")}
                            disabled={type === "edit"}
                          />
                        </Col>

                        <Col xs={12} md={6} lg={2} className="mb-3">
                          <Calender
                            setLabel={(date) => setLabel(date, "bill_date")}
                            selectedDate={formData.bill_date}
                            calenderlabel="Bill Date"
                          />
                        </Col>
                      </Row>

                      {/* Row 2 */}
                      <Row></Row>

                      {/* Row 3 */}
                      <Row></Row>
                    </Container>
                  </Col>
                  <Col lg="12" className="py-3">
                    <div>
                      No Of Products : <span>{formData.product.length}</span>
                    </div>
                  </Col>
                  <Col lg="12" md="6" xs="12">
                    <div className="py-2 category-table bill">
                      {/* Desktop View: Horizontal Table */}
                      <div className="product-table-wrapper d-none d-lg-block">
                        <Table responsive className="product-table">
                          <thead>
                            <tr>
                              <th className="text-center">#</th>
                              <th style={{ minWidth: '250px' }}>Product Name</th>
                              <th className="text-center">Qty</th>
                              <th className="text-center">Unit</th>
                              <th className="text-center">Price / Unit</th>
                              <th className="text-center">Amount</th>
                              <th className="text-center"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData.product &&
                              formData.product.map((row, index) => (
                                <tr key={index}>
                                  <td className="text-center font-weight-bold">{index + 1}</td>
                                  <td>
                                    <DropDownUItest
                                      optionlist={optionlist}
                                      placeholder="Product Name"
                                      name="product_id"
                                      value={row.product_id}
                                      onChange={(updatedFormData) => {
                                        const selectedProduct = productData.find(
                                          (user) =>
                                            user.product_id === updatedFormData.product_id
                                        );
                                        setFormData({
                                          ...formData,
                                          product: formData.product.map((r, i) =>
                                            i === index
                                              ? {
                                                ...r,
                                                product_id: updatedFormData.product_id,
                                                price_unit: selectedProduct?.unit_rate || "",
                                              }
                                              : r
                                          ),
                                        });
                                      }}
                                    />
                                    {/* <input
                                      type="text"
                                      className="table-input remarks-box mt-1"
                                      placeholder="Remarks"
                                      value={row.remarks || ""}
                                      onChange={(e) => handleChange(e, "remarks", index)}
                                    /> */}
                                  </td>
                                  <td>
                                     <div className="d-flex align-items-center gap-1">
                                       <input
                                         type="text"
                                         className="table-input text-center"
                                         placeholder="qty"
                                         value={row.qty}
                                         onChange={(e) => handleChange(e, "qty", index)}
                                       />
                                       <BiPlus 
                                         className="text-primary cursor-pointer" 
                                         size={20} 
                                         onClick={() => handleOpenQtyModal(index)}
                                         title="Add Qty"
                                       />
                                     </div>
                                   </td>
                                  <td>
                                    <DropDownUI
                                      optionlist={UnitData.map((user) => ({
                                        value: user.unit_id,
                                        label: user.unit_name,
                                      }))}
                                      value={row.unit}
                                      placeholder="Unit"
                                      onChange={(updatedFormData) =>
                                        setFormData({
                                          ...formData,
                                          product: formData.product.map((r, i) =>
                                            i === index
                                              ? { ...r, unit: updatedFormData.unit }
                                              : r
                                          ),
                                        })
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      className="table-input text-center"
                                      placeholder="price"
                                      value={row.price_unit}
                                      onChange={(e) => handleChange(e, "price_unit", index)}
                                    />
                                  </td>

                                  <td>
                                    <input
                                      type="number"
                                      className="table-input text-center"
                                      placeholder="amt"
                                      value={row.total_amt}
                                      readOnly
                                    />
                                  </td>
                                  <td className="text-center">
                                    <MdDeleteForever
                                      className="delete-row-icon"
                                      size={40}
                                      onClick={() => handleDeleteRow(index)}
                                    />
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </Table>
                      </div>

                      {/* Mobile View: Responsive Grid */}
                      <div className="d-lg-none">
                        {formData.product &&
                          formData.product.map((row, index) => (
                            <div key={index} className="p-3 border rounded mb-4 bg-white shadow-sm position-relative product-card">
                               <div className="badge bg-primary position-absolute top-0 start-0 m-2">#{index + 1}</div>
                               <Row className="mt-3">
                                  <Col xs={12} className="mb-3">
                                     <label className="form-label fw-bold small">Product Name</label>
                                     <DropDownUItest
                                        optionlist={optionlist}
                                        placeholder="Product Name"
                                        name="product_id"
                                        value={row.product_id}
                                        onChange={(updatedFormData) => {
                                           const selectedProduct = productData.find(
                                              (user) => user.product_id === updatedFormData.product_id
                                           );
                                           setFormData({
                                              ...formData,
                                              product: formData.product.map((r, i) =>
                                                 i === index ? { 
                                                    ...r, 
                                                    product_id: updatedFormData.product_id, 
                                                    price_unit: selectedProduct?.unit_rate || "" 
                                                 } : r
                                              ),
                                           });
                                        }}
                                     />
                                     {/* <input
                                        type="text"
                                        className="form-control form-control-sm mt-2 remarks-box"
                                        placeholder="Remarks"
                                        value={row.remarks || ""}
                                        onChange={(e) => handleChange(e, "remarks", index)}
                                     /> */}
                                  </Col>

                                  <Col xs={12} className="mb-3">
                                      <label className="form-label text-muted x-small">Qty</label>
                                      <div className="d-flex align-items-center gap-2">
                                        <input
                                           type="text"
                                           className="form-control bg-light"
                                           placeholder="Qty"
                                           value={row.qty}
                                           onChange={(e) => handleChange(e, "qty", index)}
                                        />
                                        <button 
                                          className="btn btn-sm btn-outline-primary p-1 rounded-circle" 
                                          style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                          onClick={() => handleOpenQtyModal(index)}
                                        >
                                          <BiPlus size={18} />
                                        </button>
                                      </div>
                                   </Col>

                                  <Col xs={12} className="mb-3">
                                     <label className="form-label text-muted x-small">Unit</label>
                                     <DropDownUI
                                        optionlist={UnitData.map((user) => ({
                                           value: user.unit_id,
                                           label: user.unit_name,
                                        }))}
                                        value={row.unit}
                                        placeholder="Unit"
                                        onChange={(updatedFormData) =>
                                           setFormData({
                                              ...formData,
                                              product: formData.product.map((r, i) =>
                                                 i === index ? { ...r, unit: updatedFormData.unit } : r
                                              ),
                                           })
                                        }
                                     />
                                  </Col>

                                  <Col xs={12} className="mb-3">
                                     <label className="form-label text-muted x-small">Price/Unit</label>
                                     <input
                                        type="number"
                                        className="form-control bg-light"
                                        placeholder="Price"
                                        value={row.price_unit}
                                        onChange={(e) => handleChange(e, "price_unit", index)}
                                     />
                                  </Col>



                                  <Col xs={12} className="mb-3">
                                     <label className="form-label fw-bold x-small">Total Amount</label>
                                     <div className="d-flex gap-2 align-items-center">
                                       <input
                                          type="text"
                                          className="form-control fw-bold bg-light-success text-center flex-grow-1"
                                          value={row.total_amt}
                                          readOnly
                                       />
                                       <MdDeleteForever
                                          className="text-danger cursor-pointer"
                                          size={28}
                                          onClick={() => handleDeleteRow(index)}
                                       />
                                     </div>
                                  </Col>
                               </Row>
                            </div>
                          ))}
                      </div>

                      <div className="btn-add-more-row">
                        <button className="btn-add-more" onClick={handleAddRow}>Add More</button>
                      </div>
                    </div>
                  </Col>
                  {/* <Col lg="12" className="text-end">
                    <div className=" text-primary">
                      <ClickButton
                        label={<>Add More</>}
                        onClick={handleAddRow}
                      />
                    </div>
                  </Col> */}
                </Row>
              </Container>
            </div>
            <div className="my-3">
              <Container>
                <Row>
                  <Col lg="5">{/* <PayMents /> */}</Col>
                  <Col lg="7">
                    <div className="inside my-3">
                    <div className="payment-card shadow-sm p-4 bg-white rounded-3 my-3">
                      <Row className="align-items-center mb-3">
                        <Col xs={5}>
                          <label className="fw-bold text-secondary">Total</label>
                        </Col>
                        <Col xs={7}>
                          <input
                            type="text"
                            className="table-input payment-input bg-light"
                            placeholder="Total"
                            name="total"
                            value={formData.total}
                            readOnly
                          />
                        </Col>
                      </Row>

                      <Row className="align-items-center mb-3">
                        <Col xs={5}>
                          <label className="fw-bold text-secondary">Paid</label>
                        </Col>
                        <Col xs={7}>
                          <input
                            type="number"
                            className="table-input payment-input"
                            placeholder="Paid"
                            name="paid"
                            value={formData.paid}
                            onChange={handlePaidChange}
                          />
                        </Col>
                      </Row>

                      <Row className="align-items-center mb-3">
                        <Col xs={12} md={5} className="mb-2 mb-md-0">
                          <label className="fw-bold text-secondary">Select Payment</label>
                        </Col>
                        <Col xs={12} md={7}>
                          <DropDownUI
                            optionlist={crtPaymentMethod.map((user) => ({
                              value: user.payment_method_name,
                              label: user.payment_method_name,
                            }))}
                            placeholder="Select Payment"
                            name="payment_method"
                            value={formData.payment_method}
                            onChange={(updatedFormData) => {
                              setFormData({
                                ...formData,
                                payment_method: updatedFormData.payment_method,
                              });
                            }}
                          />
                        </Col>
                      </Row>

                      <Row className="align-items-center mb-3">
                        <Col xs={5}>
                          <label className="fw-bold text-secondary">Balance</label>
                        </Col>
                        <Col xs={7}>
                          <input
                            type="text"
                            className="table-input payment-input bg-light"
                            placeholder="Balance"
                            name="balance_amount"
                            value={formData.balance_amount}
                            readOnly
                          />
                        </Col>
                      </Row>

                      <Row className="align-items-center mb-3">
                        <Col xs={5}>
                          <label className="fw-bold text-secondary">Driver Name</label>
                        </Col>
                        <Col xs={7}>
                          <input
                            type="text"
                            className="table-input payment-input"
                            placeholder="Driver Name"
                            name="driver_name"
                            value={formData.driver_name}
                            onChange={(e) => handleChange(e, "driver_name")}
                          />
                        </Col>
                      </Row>

                      <Row className="align-items-center mb-3">
                        <Col xs={5}>
                          <label className="fw-bold text-secondary">Driver Phone No</label>
                        </Col>
                        <Col xs={7}>
                          <input
                            type="text"
                            className="table-input payment-input"
                            placeholder="Driver Phone No"
                            name="driver_phone"
                            value={formData.driver_phone}
                            onChange={(e) => handleChange(e, "driver_phone")}
                          />
                        </Col>
                      </Row>

                      <Row className="align-items-center mb-3">
                        <Col xs={5}>
                          <label className="fw-bold text-secondary">Vehicle No</label>
                        </Col>
                        <Col xs={7}>
                          <input
                            type="text"
                            className="table-input payment-input"
                            placeholder="Vehicle No"
                            name="vehicle_no"
                            value={formData.vehicle_no}
                            onChange={(e) => handleChange(e, "vehicle_no")}
                          />
                        </Col>
                      </Row>

                      <Row className="align-items-center mb-3">
                        <Col xs={5}>
                          <label className="fw-bold text-secondary">Vehicle Type</label>
                        </Col>
                        <Col xs={7}>
                          <input
                            type="text"
                            className="table-input payment-input"
                            placeholder="Vehicle Type"
                            name="vehicle_type"
                            value={formData.vehicle_type}
                            onChange={(e) => handleChange(e, "vehicle_type")}
                          />
                        </Col>
                      </Row>

                      <Row className="align-items-center mb-3">
                        <Col xs={5}>
                          <label className="fw-bold text-secondary">Details (Optional)</label>
                        </Col>
                        <Col xs={7}>
                          <input
                            type="text"
                            className="table-input payment-input"
                            placeholder="Details(Optional)"
                            name="remark"
                            value={formData.remark}
                            onChange={handleRemarkChange}
                          />
                        </Col>
                      </Row>
                    </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
          <div className="main stick-bottom">
            <div className="w-50 ms-auto">
              <Container>
                <Row>
                  <Col lg="12">
                    <div className="text-center">
                      <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                      />

                      <div className="d-flex flex-column flex-md-row justify-content-center mt-3">
                        <div className="mx-md-2 mb-2 mb-md-0">
                          <ClickButton
                            label={<>{type === "edit" ? "Update" : "Submit"}</>}

                            onClick={
                              type === "edit"
                                ? handleUpdateSubmit
                                : handleSubmit
                            }

                          />
                        </div>

                        <div className="mx-md-2">
                          <ClickButton
                            label={<>Cancel</>}
                            onClick={() => navigate("/console/purchase/bill")}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Container>
      </div>
      <Modal show={showQtyModal} onHide={() => setShowQtyModal(false)} centered size="sm">
        <Modal.Header closeButton style={{ background: '#f8f9fa', borderBottom: 'none' }}>
          <Modal.Title className="fs-6 fw-bold">Add More</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 pt-2">
          <Row className="mb-4">
            <Col>
              <label className="form-label small text-muted mb-2">Additional quantity to add:</label>
              <input
                type="text"
                className="form-control shadow-sm border-2"
                placeholder="0"
                value={additionalQty}
                onChange={(e) => setAdditionalQty(e.target.value)}
                autoFocus
                style={{ borderRadius: '10px' }}
              />
            </Col>
          </Row>
          <div className="d-grid shadow-sm" style={{ borderRadius: '10px' }}>
            <button 
              className="btn btn-dark btn-sm rounded-4 fw-bold py-2"
              onClick={handleQtyAddition}
              style={{ background: '#f32e4fff', border: 'none', color: '#000' }}
            >
              ADD
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
// const PurchaseBillEntry = () => {
//   const location = useLocation();
//   const { type, rowData } = location.state || {};
//   const navigate = useNavigate();

//   const initialState = type === 'edit' ? { ...rowData } : {
//     party_id: '',
//     bill_no: '',
//     bill_date: '',
//     total: '',
//     paid: '',
//     balance_amount: '',
//     final_total: '',
//     discount_all: '',
//     total_discountall: '',
//     taxover_amt: '',
//     taxover_percentage: '',
//     round_off_checkbox: '',
//     product: [{ product_id: '', qty: '', unit: '', price_unit: '', discount_percentage: '', discount_amt: '', tax_percentage: '', tax_amt: '', total_amt: '' }]

//   };
//   const [formData, setFormData] = useState(initialState);

//   const handleChange = (e, fieldName) => {
//     const value = e.target ? e.target.value : e.value;

//     setFormData({
//       ...formData,
//       [fieldName]: value
//     });
//   };
//   const setLabel = (value, field) => {
//     setFormData({
//       ...formData,
//       [field]: moment(value).format("YYYY-MM-DD") // Update the specified field in formData with the provided value
//     });
//   };
//   const [loading, setLoading] = useState(false);
//   const [showAlert, setShowAlert] = useState(false);
//   const [productData, setProductData] = useState([]);
//   useEffect(() => {
//     const fetchProductData = async () => {
//       try {
//         const companyId = localStorage.getItem('companyId');
//         const response = await fetch('https://node.zentexus.com/product/list/' + companyId, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify({
//             search_text: ''
//           })
//         });

//         if (!response.ok) {
//           throw new Error('Failed to fetch data');
//         }

//         const responseData = await response.json();
//         setLoading(responseData);
//
//         if (responseData.status === 200) {
//           setProductData(responseData.data);
//         } else {
//           throw new Error(responseData.msg);
//         }
//       } catch (error) {
//         setLoading();
//
//       }
//     };

//     fetchProductData(); // Call fetchData directly in useEffect

//   }, []);
//   const [UnitData, setUnitData] = useState([])
//   const fetchUnitData = async () => {
//     try {
//       const companyId = localStorage.getItem('companyId');
//       const response = await fetch('https://node.zentexus.com/unit/list/' + companyId, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           search_text: ''
//         })
//       });
//       if (!response.ok) {
//         throw new Error('Failed to fetch data');
//       }

//       const responseData = await response.json();
//
//       setLoading(false);
//       if (responseData.status === 200) {
//         setUnitData(responseData.data);

//       } else {
//         throw new Error(responseData.msg);
//       }
//     } catch (error) {
//       setLoading(false);
//
//     }
//   };
//   const [purchseParty, setPurchaseparty] = useState([])
//   const fetchDatapurchseParty = async () => {
//     try {
//       const companyId = localStorage.getItem('companyId');
//       const response = await fetch('https://node.zentexus.com/purchaseparty/list/' + companyId, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           search_text: ''
//         })
//       });

//       if (!response.ok) {
//         throw new Error('Failed to fetch data');
//       }

//       const responseData = await response.json();
//
//       setLoading(false);
//       if (responseData.status === 200) {
//         setPurchaseparty(responseData.data);

//       } else {
//         throw new Error(responseData.msg);
//       }
//     } catch (error) {
//       setLoading(false);
//
//     }
//   };
//   useEffect(() => {
//     fetchUnitData(); // Call fetchData directly in useEffect
//     fetchDatapurchseParty();
//   }, []);
//   const errorAlert = (input) => {
//     toast.error(input, {
//       position: "top-center",
//       autoClose: 3000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       theme: "colored",
//     });
//   }
//   const successAlert = (success) => {
//     toast.success(success, {
//       position: "top-center",
//       autoClose: 3000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       theme: "colored",

//     });
//   }
//   const handleSubmit = async () => {
//     try {

//       const companyId = localStorage.getItem('companyId');
//       const response = await fetch('https://node.zentexus.com/purchasebill/create/' + companyId, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(formData)
//       });
//
//       const responseData = await response.json();

//

//       if (responseData.status === 200) {
//         setFormData({
//           party_id: '',
//           bill_no: '',
//           bill_date: '',
//           total: '',
//           paid: '',
//           balance_amount: '',
//           final_total: '',
//           discount_all: '',
//           total_discountall: '',
//           taxover_amt: '',
//           taxover_percentage: '',
//           round_off_checkbox: '',
//           product: [{ product_id: '', qty: '', unit: '', price_unit: '', discount_percentage: '', discount_amt: '', tax_percentage: '', tax_amt: '', total_amt: '' }]

//         })
//         successAlert(responseData.msg)
//         setTimeout(() => {
//           navigate("/console/purchase/bill");
//         }, 2000);
//       }
//       else if (responseData.status === 400) {
//         toast.error('Missing required fields!', {
//           position: "top-center",
//           autoClose: 2000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//         });
//       }
//       else {
//         setShowAlert(true);
//       }

//     } catch (error) {
//
//     }
//   };
//   const handleUpdateSubmit = async () => {
//     try {
//       const response = await fetch('https://node.zentexus.com/user/update/joyg67j8t689t', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ // Include the company ID in the request

//         }),
//       });

//       if (!response.ok) {
//         throw new Error('Failed to update company');
//       }

//       const responseData = await response.json();
//

//       if (responseData.status === 200) {
//         toast.success('User updated successfully!', {
//           position: "top-center",
//           autoClose: 2000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//         });
//         setTimeout(() => {
//           navigate("/console/purchase/bill/create");
//         }, 2000);

//         // Navigate to the user list page after a delay

//       } else {
//
//       }
//     } catch (error) {
//
//     }

//     setLoading(false);
//   };
//   useEffect(() => {
//     setLoading(true)

//     setTimeout(() => {
//       setLoading(false)
//     })
//   })

//   return (
//     <>

//       <div>
//         <div className='main stick-top'>
//           <Container fluid>
//             <Row>
//               <Col lg='12'><PageHead pagehead={<>Purchase Bill</>} onClick={() => navigate(-1)} /></Col>
//             </Row>
//           </Container>
//         </div>
//         <div className='main my-3'>
//           <div>
//             <Container fluid>
//               <Row>
//                 <Col lg='12'>
//                   <Table>
//                     <tr>
//                       <td>
//                         <div className='w-75'>
//                           <DropDownUI
//                             optionlist={purchseParty.map(user => ({
//                               value: user.party_id,
//                               label: user.party_name
//                             }))}
//                             placeholder='Party Name'
//                             labelname='Party Name'
//                             name='party_id'
//                             value={type === 'edit' ? formData.party_id : formData.party_id}
//                             onChange={(updatedformData) => setFormData({ ...formData, party_id: updatedformData.party_id })}
//                           />
//                         </div>
//                         <div className='instant-btn'>
//                           <InstantCreate label={<BiPlus />} className='instant-add'></InstantCreate>
//                         </div>
//                       </td>
//                       <td className='mx-auto float-end'>
//                         <div>
//                           <span>
//                             <TextInputForm placeholder={'Bill Number'}
//                               labelname={'Bill Number'}
//                               name='bill_no'
//                               value={type === 'edit' ? formData.bill_no : formData.bill_no}
//                               onChange={(e) => handleChange(e, 'bill_no')} />
//                           </span>
//                         </div>
//                         <div>
//                           <div className='text-left'>
//                           </div>
//                           <Calender setLabel={(date) => setLabel(date, 'bill_date')} selectedDate={type === 'edit' ? formData.bill_date : ''} calenderlabel="BillDate" />
//                         </div>
//                       </td>
//                     </tr>
//                   </Table>
//                 </Col>
//                 <Col lg='12' className='py-3'>
//                   <div>No Of Products : <span>1</span></div>
//                 </Col>
//                 <Col lg='12' md='6' xs='12'>
//                   <div className="py-2 category-table bill">
//                     <Table>
//                       <thead className=''>
//                         <tr>
//                           <th rowSpan={2}>#</th>
//                           <th rowSpan={2} className='wrdbrk w-20'>Product Name</th>
//                           <th rowSpan={2} className='wrdbrk w-7'>Qty</th>
//                           <th rowSpan={2} className='wrdbrk w-10'>Unit</th>
//                           <th rowSpan={2} className='wrdbrk w-7'>Price / Unit</th>
//                           <th colSpan={2} className='wrdbrk w-15'>Discount</th>
//                           <th colSpan={2} className='wrdbrk w-15' >Tax</th>
//                           <th rowSpan={2} className='wrdbrk'>Amount</th>
//                         </tr>
//                         <tr>
//                           <th>%</th>
//                           <th className='w-10'>Amount</th>
//                           <th >%</th>
//                           <th className='w-10'>Amount</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td>1</td>
//                           <td>
//                             <div>
//                               <DropDownUI
//                                 optionlist={productData.map(user => ({
//                                   value: user.product_id,
//                                   label: user.product_name
//                                 }))}
//                                 placeholder='ProductName'
//                                 name='product_id'
//                                 value={formData.product_id}
//                                 onChange={(updatedFormData) => {
//                                   setFormData({ ...formData, product_id: updatedFormData.product_id })
//                                 }}
//                               />
//                             </div>
//                             <div>
//                               <TextInputForm placeholder={"Remarks"} />
//                             </div>
//                           </td>
//                           <td>
//                             <TextInputForm
//                               placeholder={'qty'}
//                               name='qty'
//                               value={formData.qty}
//                               onChange={(e) => handleChange(e, 'qty')}
//                             ></TextInputForm>
//                           </td>
//                           <td>
//                             <DropDownUI
//                               optionlist={UnitData.map(user => ({
//                                 value: user.unit_id,
//                                 label: user.unit_name
//                               }))}
//                               placeholder='Unit'
//                               name='unit'
//                               value={formData.unit}
//                               onChange={(updatedFormData) => {
//                                 setFormData({ ...formData, unit: updatedFormData.unit })
//                               }} />
//                           </td>
//                           <td>
//                             <TextInputForm
//                               placeholder={'price'}
//                               name='price'
//                               value={formData.price_unit}
//                               onChange={(e) => handleChange(e, 'price_unit')}
//                             />

//                           </td>
//                           <td>
//                             <TextInputForm
//                               placeholder={'discount_percentage'}
//                               name='discount_percentage'
//                               value={formData.discount_percentage}
//                               onChange={(e) => handleChange(e, 'discount_percentage')}
//                             />
//                           </td>
//                           <td>
//                             <TextInputForm
//                               placeholder={'discount_amt'}
//                               name='discount_amt'
//                               value={formData.discount_amt}
//                               onChange={(e) => handleChange(e, 'discount_amt')}
//                             />
//                           </td>

//                           <td className='w-10 text-left'>
//                             <DropDownUI
//                               optionlist={alltax}
//                               placeholder='Tax'
//                               name='tax_percentage'
//                               value={formData.tax_percentage}
//                               onChange={(updatedFormData) => {
//                                 setFormData({ ...formData, tax_percentage: updatedFormData.tax_percentage })
//                               }}
//                             />
//                           </td>
//                           <td>
//                             <TextInputForm
//                               placeholder={'tax_amt'}
//                               name='tax_amt'
//                               value={formData.tax_amt}
//                               onChange={(e) => handleChange(e, 'tax_amt')}

//                             />
//                           </td>
//                           <td>
//                             <TextInputForm
//                               placeholder={'amt'}
//                               name='total_amt'
//                               value={formData.total_amt}
//                               onChange={(e) => handleChange(e, 'total_amt')}
//                             />
//                           </td>
//                           <td className='' >
//                             <div className=''>
//                               <ClickButton label={<>Add More</>} />
//                             </div>
//                           </td>
//                           <td>
//                             <Delete label={<MdDeleteForever />}></Delete>
//                           </td>
//                         </tr>
//                       </tbody>
//                     </Table>
//                   </div>
//                 </Col>
//               </Row>
//             </Container>
//           </div>
//           <div className='my-3'>
//             <Container>
//               <Row>
//                 <Col lg='5'>
//                   {/* <PayMents /> */}
//                 </Col>
//                 <Col lg='7'>
//                   <div className='inside my-3'>
//                     <Table>
//                       <tr>
//                         <td>Total</td>
//                         <td></td>
//                         <td className='w-25'>
//                           <TextInputForm
//                             placeholder={'Total'}
//                             name='total'
//                             value={type === 'edit' ? formData.total : formData.total}
//                           />
//                         </td>
//                       </tr>
//                       {/* <tr>
//                         <td>Discount</td>
//                         <td className='w-10'>
//                           <TextInputForm
//                             placeholder={'discount_all'}
//                             name='discount_all'
//                             value={type === 'edit' ? formData.discount_all : formData.discount_all}
//                             onChange={(e) => handleChange(e, 'discount_all')}
//                             disabled={formData.product.some(row => row.discount_percentage)}
//                           />

//                         </td>
//                         <td className='w-25'>
//                           <TextInputForm
//                             placeholder={'TotalDiscount'}
//                             name='total_discountall'
//                             value={type === 'edit' ? formData.total_discountall : formData.total_discountall}
//                             onChange={(e) => handleChange(e, 'total_discountall')}
//                             disabled={formData.product.some(row => row.discount_amt)}
//                           />

//                         </td>
//                       </tr> */}

//                       <tr>
//                         {/* <td><input type="checkbox" className='mx-2' onChange={(e) => handleChange(e, 'round_off_checkbox')} /> Round off</td>
//                         <td className='w-15'>
//                           <TextInputForm
//                             placeholder={'round_off'}
//                             name='round_off'
//                             value={type === 'edit' ? formData.round_off : formData.round_off}
//                             onChange={(e) => handleChange(e, 'round_off')}
//                           />
//                         </td> */}
//                         {/* <td className='w-25'>
//                           <TextInputForm
//                             placeholder={'finaltotal'}
//                             name='final_total'
//                             value={type === 'edit' ? formData.final_total : formData.final_total}
//                             onChange={(e) => handleChange(e, 'final_total')}
//                           />
//                         </td> */}
//                       </tr>
//                       <tr>
//                         <td>Paid</td>
//                         <td></td>
//                         <td className='w-25'>
//                           <TextInputForm
//                             placeholder={'Paid'}
//                             name='paid'

//                             value={type === 'edit' ? formData.paid : formData.paid}

//                           />
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>Balance</td>
//                         <td></td>
//                         <td className='w-25'>
//                           <TextInputForm
//                             placeholder={'balance'}
//                             name='balance_amount'
//                             value={type === 'edit' ? formData.balance_amount : formData.balance_amount}
//                             onChange={(e) => handleChange(e, 'balance_amount')}
//                           />
//                         </td>
//                       </tr>
//                     </Table>
//                   </div>
//                 </Col>
//               </Row>
//             </Container>
//           </div>
//         </div>
//         <div className='main stick-bottom'>
//           <div className='w-50 ms-auto'>
//             <Container>
//               <Row>
//                 <Col lg="12">
//                   <div className='text-center'>
//                     {type === 'edit' ? (
//                       <>
//                         <ToastContainer
//                           position="bottom-center"
//                           autoClose={3000}
//                           hideProgressBar={false}
//                           newestOnTop={false}
//                           closeOnClick
//                           rtl={false}
//                           pauseOnFocusLoss
//                           draggable
//                           pauseOnHover
//                           theme="light"
//                         />
//                         <span className='mx-2'>
//                           <ClickButton label={<>Update</>} onClick={handleUpdateSubmit}></ClickButton>

//                         </span>

//                         <span className='mx-2'>
//                           <ClickButton label={<>Cancel</>} onClick={() => navigate("/console/purchase/bill")}></ClickButton>
//                         </span>
//                       </>

//                     ) : (
//                       <>
//                         <ToastContainer
//                           position="bottom-center"
//                           autoClose={3000}
//                           hideProgressBar={false}
//                           newestOnTop={false}
//                           closeOnClick
//                           rtl={false}
//                           pauseOnFocusLoss
//                           draggable
//                           pauseOnHover
//                           theme="light"
//                         />
//                         <span className='mx-2'>
//                           <ClickButton label={<>Submit</>} onClick={handleSubmit}></ClickButton>

//                         </span>

//                         <span className='mx-2'>
//                           <ClickButton label={<>Cancel</>} onClick={() => navigate("/console/purchase/bill")}></ClickButton>
//                         </span>
//                       </>
//                     )}
//                   </div>
//                 </Col>
//               </Row>
//             </Container>
//           </div>
//         </div>
//       </div>
//     </>

//   )
// }

const PurchaseReturnEntry = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    });
  }, []);
  return (
    <>
      {loading ? (
        <PropagateLoader
          className="text-center pt-5 "
          color={"#d43333"}
          loading={loading}
          size={18}
        />
      ) : (
        <div>
          <div className="main stick-top">
            <Container>
              <Row>
                <Col lg="12" className="py-3">
                  <PageHead
                    pagehead={<>Purchase Return</>}
                    onClick={() => navigate(-1)}
                  />
                </Col>
                <Col lg="12" className="py-3">
                  <Table>
                    <tr>
                      <td>
                        <div className="w-75">
                          <DropDown />
                        </div>
                      </td>
                      <td className="mx-auto float-end">
                        <div>
                          {" "}
                          Order No : <span>10</span>
                        </div>
                        <div>
                          <div className="text-left">Order Date </div>{" "}
                          <Calender />
                        </div>
                        <div>
                          <div>Due Date </div> <Calender />
                        </div>
                      </td>
                    </tr>
                  </Table>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="main my-3">
            <div>
              <Container>
                <Row>
                  <Col lg="12" className="py-3">
                    <div>
                      No Of Products : <span>15</span>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="py-2 category-table bill">
                      <Table>
                        <thead className="">
                          <tr>
                            <th rowSpan={2}>#</th>
                            <th rowSpan={2} className="wrdbrk w-20">
                              Product Name
                            </th>
                            <th rowSpan={2} className="wrdbrk w-7">
                              Qty
                            </th>
                            <th rowSpan={2} className="wrdbrk w-10">
                              Unit
                            </th>
                            <th rowSpan={2} className="wrdbrk w-7">
                              Price / Unit
                            </th>
                            <th colSpan={2} className="wrdbrk w-15">
                              Discount
                            </th>
                            <th colSpan={2} className="wrdbrk w-15">
                              Tax
                            </th>
                            <th rowSpan={2} className="wrdbrk">
                              Amount
                            </th>
                          </tr>
                          <tr>
                            <th>%</th>
                            <th className="w-10">Amount</th>
                            <th>%</th>
                            <th className="w-10">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <Dltbtn
                                lable={
                                  <>
                                    <MdOutlineDeleteOutline />
                                  </>
                                }
                              />
                            </td>
                            <td>
                              <DropDown />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                            <td className="wrdbrk">
                              <DropDown />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                            <td className="wrdbrk">
                              <DropDown />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Dltbtn
                                lable={
                                  <>
                                    <MdOutlineDeleteOutline />
                                  </>
                                }
                              />
                            </td>
                            <td>
                              <DropDown />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                            <td className="wrdbrk">
                              <DropDown />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                            <td className="wrdbrk">
                              <DropDown />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                            <td>
                              <TextInputForm />
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
            <div className="my-3">
              <Container>
                <Row>
                  <Col lg="5">{/* <PayMents /> */}</Col>
                  <Col lg="7">
                    <div className="inside my-3">
                      <Table>
                        <tr>
                          <td>Total</td>
                          <td></td>
                          <td className="w-25">
                            {" "}
                            <TextInputForm />
                          </td>
                        </tr>
                        <tr>
                          <td>Discount</td>
                          <td className="w-5">
                            {" "}
                            <TextInputForm />
                          </td>
                          <td className="w-25">
                            {" "}
                            <TextInputForm />
                          </td>
                        </tr>
                        <tr>
                          <td>Tax</td>
                          <td className="w-5">
                            {" "}
                            <TextInputForm />
                          </td>
                          <td className="w-25">
                            {" "}
                            <TextInputForm />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input type="checkbox" className="mx-2" /> Round off
                          </td>
                          <td></td>
                          <td className="w-25">
                            {" "}
                            <TextInputForm />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input type="checkbox" className="mx-2" /> Paid
                          </td>
                          <td></td>
                          <td className="w-25">
                            {" "}
                            <TextInputForm />
                          </td>
                        </tr>
                        <tr>
                          <td>Balance</td>
                          <td></td>
                          <td className="w-25">
                            {" "}
                            <TextInputForm />
                          </td>
                        </tr>
                      </Table>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
          <div className="main stick-bottom">
            <div className="w-50 ms-auto">
              <Container>
                <Row>
                  <Col lg="12">
                    <div className="text-end">
                      <span className="mx-2">
                        {" "}
                        <Buttons lable={<>Print</>} />
                      </span>
                      <span className="mx-2">
                        {" "}
                        <Buttons lable={<>Save & New</>} />
                      </span>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export { PurchaseBillEntry, PurchaseReturnEntry };

